import httpClient from './httpClient'

const END_POINT_DEVICES = '/devices/'
const END_POINT_MODES = '/modes/'
const END_POINT_ALT_MODE = '/alt_mode/'
const END_POINT_MODE_PARAM = '/tracker_config/mode_param/?remote=1'
const END_POINT_DIAGNOSTICS = '/diagnostics/'

const getModes = (device_id) => httpClient.get(END_POINT_DEVICES + device_id + END_POINT_MODES)
const getAltMode = (device_id) => httpClient.get(END_POINT_DEVICES + device_id + END_POINT_ALT_MODE)
const patchAltMode = (device_id, body) => httpClient.patch(END_POINT_DEVICES + device_id + END_POINT_ALT_MODE, body)
const patchModeParam = (device_id, body) => httpClient.patch(END_POINT_DEVICES + device_id + END_POINT_MODE_PARAM, body)
const getDiagnostics = (device_id) => httpClient.get(END_POINT_DEVICES + device_id + END_POINT_DIAGNOSTICS)

export { getModes, getAltMode, patchAltMode, patchModeParam, getDiagnostics }
